import React, { useEffect, useState } from "react";
import { Box, Heading, Text } from "@chakra-ui/react";
import ReactHlsPlayer from "react-hls-player";
import { getEndpoint } from "../constants/api";

export default function CatchAll() {
    const [streamTitle, setStreamTitle] = useState("");
    const [streamSrc, setStreamSrc] = useState("");
    const [centerName, setCenterName] = useState("");

    // -----------------------------
    // Fetch stream settings
    // -----------------------------
    const getStreamSettings = async () => {
        try {
            const res = await fetch(getEndpoint("stream"));
            const data = await res.json();
            setStreamTitle(data.title || "");
            setStreamSrc(data.src || "");
        } catch (err) {
            console.error("Failed to fetch stream settings:", err);
        }
    };

    // -----------------------------
    // Retrieve center name from session
    // -----------------------------
    const getCenterNameFromSession = () => {
        const pack = sessionStorage.getItem("pack");
        if (!pack) return "";
        try {
            const { centerName } = JSON.parse(pack);
            return centerName || "";
        } catch (e) {
            return "";
        }
    };

    const getYoutubeEmbedUrl = (url) => {
        if (!url) return "";

        // Extract video ID from various formats
        // 1. youtube.com/watch?v=ID
        // 2. youtu.be/ID
        // 3. youtube.com/embed/ID
        // 4. youtube.com/live/ID

        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|live\/)([^#&?]*).*/;
        const match = url.match(regExp);

        if (match && match[2].length === 11) {
            return `https://www.youtube.com/embed/${match[2]}`;
        }

        return url;
    };

    const isIframeStream = (url) => {
        return url.includes("youtube.com") || url.includes("youtu.be") || url.includes("player.castr");
    };

    useEffect(() => {
        getStreamSettings();
        setCenterName(getCenterNameFromSession());
    }, []);

    return (
        <Box padding="20px">
            <Heading as="h2" size="lg" marginBottom="10px">
                {streamTitle || "Untitled Stream"}
            </Heading>
            <Text marginBottom="20px">
                Viewing Center: {centerName || "Unknown"}
            </Text>




            {
                !streamSrc ? (
                    <Text>No stream available at the moment. Please check back later.</Text>
                ) : isIframeStream(streamSrc) ? (
                    <iframe
                        src={getYoutubeEmbedUrl(streamSrc)}
                        width="100%"
                        style={{ aspectRatio: "16/9", minHeight: "340px" }}
                        frameBorder="0"
                        scrolling="no"
                        allow="autoplay"
                        allowFullScreen
                        webkitallowFullScreen
                        mozallowFullScreen
                        oallowFullScreen
                        msallowFullScreen
                        title="stream"
                    />

                ) : (
                    <ReactHlsPlayer
                        src={streamSrc}
                        autoPlay
                        controls
                        width="100%"
                        height="auto"
                    />
                )
            }

        </Box >
    );
}
